import * as React from 'react';
import { ExternalLink } from 'components';

export interface PhoneExternalLinkProps {
	phoneCode?: string;
	phoneNumber: string;
}

export const PhoneExternalLink: React.FC<PhoneExternalLinkProps> = props => {
	const { phoneCode = '', phoneNumber } = props;
	return (
		<ExternalLink href={`tel:${phoneCode} ${phoneNumber}`} text={`${phoneCode} ${phoneNumber}`} />
	);
};

export default PhoneExternalLink;
